import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationMap = ({ currentLanguage }) => {
  const officeLocation = {
    name: 'Peter & Partners Advocates LLP',
    address: 'Westlands Business Centre, 2nd Floor, Westlands Road, Nairobi, Kenya',
    lat: -1.2634,
    lng: 36.8084,
    mapUrl: 'https://www.google.com/maps?q=-1.2634,36.8084&z=15&output=embed'
  };

  const handleDirectionsClick = () => {
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${officeLocation.lat},${officeLocation.lng}`;
    window.open(directionsUrl, '_blank');
  };

  const handleViewLargerMapClick = () => {
    const mapUrl = `https://www.google.com/maps?q=${officeLocation.lat},${officeLocation.lng}&z=15`;
    window.open(mapUrl, '_blank');
  };

  return (
    <div className="bg-white rounded-lg shadow-lg border border-border overflow-hidden">
      <div className="p-6 lg:p-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="text-xl font-semibold text-text-primary mb-2">
              {currentLanguage === 'en' ? 'Find Our Office' : 'Pata Ofisi Yetu'}
            </h3>
            <p className="text-text-secondary">
              {currentLanguage === 'en' ?'Located in the heart of Westlands, Nairobi' :'Iko katikati ya Westlands, Nairobi'
              }
            </p>
          </div>
          
          <div className="flex items-center space-x-2">
            <button
              onClick={handleDirectionsClick}
              className="p-2 text-primary hover:bg-surface/10 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              title={currentLanguage === 'en' ? 'Get Directions' : 'Pata Maelekezo'}
            >
              <Icon name="Navigation" size={20} />
            </button>
            
            <button
              onClick={handleViewLargerMapClick}
              className="p-2 text-primary hover:bg-surface/10 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              title={currentLanguage === 'en' ? 'View Larger Map' : 'Ona Ramani Kubwa'}
            >
              <Icon name="Maximize2" size={20} />
            </button>
          </div>
        </div>

        {/* Office Details */}
        <div className="mb-6 p-4 bg-surface/10 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="MapPin" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
            <div>
              <h4 className="font-medium text-text-primary mb-1">{officeLocation.name}</h4>
              <p className="text-text-secondary text-sm">{officeLocation.address}</p>
            </div>
          </div>
        </div>

        {/* Map Container */}
        <div className="relative w-full h-80 lg:h-96 rounded-lg overflow-hidden border border-border">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Peter & Partners Advocates LLP Office Location"
            referrerPolicy="no-referrer-when-downgrade"
            src={officeLocation.mapUrl}
            className="absolute inset-0"
          />
          
          {/* Map Overlay for Loading State */}
          <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
            <div className="text-center">
              <Icon name="MapPin" size={48} color="var(--color-primary)" className="mx-auto mb-2" />
              <p className="text-text-secondary">
                {currentLanguage === 'en' ? 'Loading map...' : 'Inapakia ramani...'}
              </p>
            </div>
          </div>
        </div>

        {/* Map Actions */}
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleDirectionsClick}
            className="flex-1 flex items-center justify-center space-x-2 px-4 py-3 bg-primary text-white rounded-lg hover:bg-accent transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            <Icon name="Navigation" size={18} />
            <span className="font-medium">
              {currentLanguage === 'en' ? 'Get Directions' : 'Pata Maelekezo'}
            </span>
          </button>
          
          <button
            onClick={handleViewLargerMapClick}
            className="flex-1 flex items-center justify-center space-x-2 px-4 py-3 border border-border text-text-primary rounded-lg hover:bg-surface/10 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            <Icon name="ExternalLink" size={18} />
            <span className="font-medium">
              {currentLanguage === 'en' ? 'View in Google Maps' : 'Ona katika Google Maps'}
            </span>
          </button>
        </div>

        {/* Accessibility Information */}
        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} color="#3B82F6" className="mt-0.5 flex-shrink-0" />
            <div>
              <h5 className="font-medium text-blue-900 mb-1">
                {currentLanguage === 'en' ? 'Accessibility Information' : 'Taarifa za Upatikanaji'}
              </h5>
              <p className="text-blue-800 text-sm">
                {currentLanguage === 'en' ?'Our office is wheelchair accessible with elevator access to the 2nd floor. Parking is available on-site.' :'Ofisi yetu inaweza kufikiwa na viti vya magurudumu na lifti ya kwenda ghorofa ya pili. Maegesho ya magari yapatikana.'
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMap;